import { render, staticRenderFns } from "./homeNews.vue?vue&type=template&id=51809d28&scoped=true"
import script from "./homeNews.vue?vue&type=script&lang=js"
export * from "./homeNews.vue?vue&type=script&lang=js"
import style0 from "./homeNews.vue?vue&type=style&index=0&id=51809d28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51809d28",
  null
  
)

export default component.exports